import { render, staticRenderFns } from "./identificacion-evaluacion-productos-servicios.vue?vue&type=template&id=25cd0178&scoped=true&"
import script from "./identificacion-evaluacion-productos-servicios.vue?vue&type=script&lang=js&"
export * from "./identificacion-evaluacion-productos-servicios.vue?vue&type=script&lang=js&"
import style0 from "./identificacion-evaluacion-productos-servicios.vue?vue&type=style&index=0&id=25cd0178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd0178",
  null
  
)

export default component.exports